export default __webpack_public_path__ + "static/media/Frostram.8774ab98.jpg";